import { post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export const getLeasingContractList = filters => {
  const data = {
    uniqueId: filters.uniqueId,
    partnerName: filters.partnerName
  };
  return post(`${url}/leasingDocument/leasing-contract-list`, data);
};

export const getLeasingOfferContractData = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/contract-data`, { documentId: documentId, siteId: siteId });
};

export function saveLeasingContract(contractSelected) {
  return post(`${url}/leasingDocument/save-leasing-contract`, contractSelected);
}

export function recomputeSimulationsForModification(offer) {
  return post(`${url}/leasingDocument/recompute-simulations-for-modification`, offer);
}
